import React from "react";

import {DayPicker} from "react-day-picker";
import {ConnectedProps, connect} from "react-redux";

import {
    confirmConfirmDialog,
    hideAlertDialog,
    hideConfirmDialog,
    hideDateDialog,
    pickDateForDateDialog,
} from "@client/features/dialogs";
import {hideActiveHelp} from "@client/features/scenes";

import * as dates from "@client/dates";
import * as typography from "@client/shared/typography";

import {Button, ButtonGroup} from "@client/components/Button";
import {Modal} from "@client/components/Modal";
import {Prose} from "@client/components/Prose";
import {RootState} from "@client/store";

const mapDispatchToProps = {
    confirmConfirmDialog,
    hideAlertDialog,
    hideConfirmDialog,
    hideDateDialog,
    hideActiveHelp,
    pickDateForDateDialog,
};

const mapStateToProps = (state: RootState) => ({
    ...state.dialogs,
});

type Props = ConnectedProps<typeof connector>;

export class Dialogs extends React.Component<Props> {
    render() {
        const dateForDialog =
            this.props.isShowingDateDialog === false
                ? new Date()
                : dates.parseISO(this.props.isShowingDateDialog);

        return (
            <>
                <Modal
                    contentLabel="Alert"
                    isOpen={this.props.isShowingAlertDialog}
                    onRequestClose={this.props.hideAlertDialog}
                >
                    <typography.Title>{this.props.message}</typography.Title>
                    <Prose text={this.props.body} />
                    <Button onClick={this.props.hideAlertDialog}>Got it</Button>
                </Modal>
                <Modal
                    contentLabel="Confirm"
                    isOpen={this.props.isShowingConfirmDialog}
                    onRequestClose={this.props.hideConfirmDialog}
                >
                    <typography.Title>{this.props.message}</typography.Title>
                    <Prose text={this.props.body} />
                    <ButtonGroup>
                        <Button onClick={this.props.confirmConfirmDialog}>
                            Confirm
                        </Button>
                        <Button onClick={this.props.hideConfirmDialog}>
                            Never mind
                        </Button>
                    </ButtonGroup>
                </Modal>

                <Modal
                    contentLabel="Pick Date"
                    isOpen={this.props.isShowingDateDialog !== false}
                    onRequestClose={this.props.hideDateDialog}
                >
                    <div className="flex items-center gap-2">
                        <div className="flex-1">
                            <typography.Title>Choose date</typography.Title>
                        </div>
                        {dates.formatISO(dateForDialog, {
                            representation: "date",
                        }) !=
                            dates.formatISO(new Date(), {
                                representation: "date",
                            }) && (
                            <button
                                type="button"
                                className="text-sm font-semibold"
                                onClick={() =>
                                    this.props.pickDateForDateDialog(new Date())
                                }
                            >
                                Today
                            </button>
                        )}
                    </div>
                    <DayPicker
                        defaultMonth={dateForDialog}
                        selected={dateForDialog}
                        onDayClick={this.props.pickDateForDateDialog}
                    />
                </Modal>
            </>
        );
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(Dialogs);
